<template>
  <div class="d-flex-column justify-start align-start gap-5">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t("order_details.delivery_option") }}
      </label>
      <ItemTooltip :text="selectedOptionDescription" />
    </div>
    <DropDown
      :placeholder="$t('calculators_common.select_platform')"
      :drop-items="getKeyedDeliveryOption"
      :select-drop-item="selectDrop"
      :selected-item="selectedDelivery"
      v-if="!$isMobile() && !$isTablet()"
    />

    <BottomSheetPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('order_details.delivery_option')"
      :show-title="false"
      :items="getKeyedDeliveryOption"
      item-key="id"
      :selected-item="selectedDelivery"
      :select-filter="selectDrop"
      :allow-null="false"
    />
  </div>
</template>
<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "./ItemTooltip.vue";
import BottomSheetPicker from "~/components/common/BottomSheetPicker.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const getKeyedDeliveryOption = computed(() => {
  return gameStore.getGamePack?.pack_options
    ?.filter((op) => op.slug === "delivery_option")
    ?.reduce((accumulator, value) => {
      return {
        ...accumulator,
        [value.id]: `<span>${
          value.title
        }</span> <span class='t-blue text-capitalize'>${renderPrice(
          value
        )}</span>`,
      };
    }, {});
});

const selectDrop = (key, value) => {
  const option = gameStore.getGamePack?.pack_options?.find(
    (op) => op.id == value
  );
  if (option) {
    selectOption(option);
  }
};
const selectedDelivery = computed(() => {
  const match = checkoutStore.packOptions.find(
    (key) => key in getKeyedDeliveryOption.value
  );
  if (match) {
    return match;
  }
  return null;
});

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${packOption.price}$`;
  } else {
    return `+${packOption.price}`;
  }
};
const selectedOptionDescription = computed(() => {
  const options = gameStore.getGamePack.pack_options?.filter(
    (op) => op.slug === "delivery_option"
  );
  if (options.length > 0) {
    let description = "";
    options.forEach((option) => {
      let textBreak = description.length > 0 ? "<br/>" : "";
      description = `${description}${textBreak}<p class='f-w-400'><span class='t-orange f-w-600'>${option.title}: </span>${option.description}</p>`;
    });
    return description;
  }
  return "";
});

const isOptionSelected = (packOption) => {
  const selectedOption = checkoutStore.getPackOptions.find(
    (option) => option === packOption
  );
  if (!selectedOption) {
    return false;
  }
  return true;
};
const selectOption = (option) => {
  if (!isOptionSelected(option.id)) {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  } else {
    // const otherOptions = checkoutStore.getPackOptions.filter(
    //   (packOpt) => packOpt !== option.id
    // );
    // checkoutStore.setPackOptions({
    //   options: [...otherOptions],
    // });
  }
};
</script>
